import React, { useState, FC, useEffect } from 'react';
import ImageRecognitionText from './deprecated/ImageRecognitionText';

type PropsType = {
  value: string;
  onChangeText: (value: string) => void;
};

let formText = '';

const TextRecognitionContainer: FC<PropsType> = ({ onChangeText, value }) => {
  const [imageUrls, setImageUrls] = useState<string[]>([]);

  useEffect(() => {
    formText = value;
  }, [value]);

  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files.length) {
      for (let i = 0; i < e.target.files.length; i++) {
        const reader = new FileReader();

        reader.onloadend = () => {
          if (reader.result) {
            setImageUrls((prevState) => [...prevState, (reader.result as string)]);
          }
        };

        reader.readAsDataURL(e.target.files[i]);
      }
    }
  };

  const onChangeRecognitionText = (text: string) => {
    onChangeText(`${formText}\n${text}`);
  };

  return (
        <>
            <p>
                Загрузите фотографии. Распознанный текст автоматически вставится в форму ниже<br />
                <span style={{ color: '#d45252' }}>Внимание! Проверяйте распознанный текст на наличие неточностей! Чем лучше качество фото, тем лучше распознается текст</span>
            </p>
            <div style={{ display: 'flex', alignItems: 'center', overflowX: 'auto' }}>
                {imageUrls.map((imageUrl, index) => <ImageRecognitionText imageUrl={imageUrl} key={index} onChangeText={onChangeRecognitionText} />)}
                <input style={{ minWidth: '140px' }} type="file" onChange={onChange} multiple />
            </div>
        </>
  );
};

export default TextRecognitionContainer;
